export const capitalizeFirstLetter = (input) => {
  if (typeof input !== 'string') return '';

  const match = input.match(/[a-zA-Z]/);
  if (!match) return input;

  const index = match.index;
  return (
    input.slice(0, index) + match[0].toUpperCase() + input.slice(index + 1)
  );
};

export const truncateString = (input = '', maxLength = 20) => {
  return input?.length > maxLength ? input.slice(0, maxLength) + '...' : input;
};
